/*
 * @Description: Axios 封装，支持自动刷新Token
 * @Author: ranli
 * @Date: 2025-08-05 17:58:44
 * @LastEditTime: 2026-04-24 18:34:33
 * @LastEditors: ranli
 */
import { createAxiosInstance } from '@/utils/Axios/core.js'
import { showLoading, hideLoading, showToast, errorToBack } from '@/utils/message.js'
import { useStore } from '@/stores'
// 创建实例
const service = createAxiosInstance({
  getAuth: () => {
    const _Store = useStore()
    return _Store.P_PARAMS
  },
  showLoading: () => {
    showLoading()
  },
  hideLoading: () => {
    hideLoading()
  },
  showError: message => {
    showToast.danger(message)
  },
  handle403: message => {
    errorToBack(message)
  },
})
export default service
